<template>
  <iframe :src="handoutUrl" style="position:absolute; left:0; top:0; height:100%; width:100%; border:0px;">
  
  </iframe>
</template>

<script>
import { getCourseWareByCourse, getTrainingById, syncHandoutStatus } from '../api/api'
import { VerifyDeviceBinding } from '../utils/fingerprint'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      handoutUrl: ''
    }
  },
  mounted() {
    this.getTrainingById()
    getCourseWareByCourse({//获得课件，类型为讲义type=2
      userId: this.$route.query.uId,
      trainingId: this.$route.query.tId,
      projId: this.$route.query.pId,
      courseId: this.$route.query.cId,
      type: 2//讲义
    }).then((response) => {
      document.title = response.data.data.courseName
      let handoutInfo = response.data.data.handoutInfo
      this.handoutUrl = handoutInfo.url
      if ((!handoutInfo.done) && handoutInfo.lectureMinute) {
        setTimeout(() => {
          syncHandoutStatus({//同步讲义状态
            tId: this.$route.query.tId,
            pId: this.$route.query.pId,
            cId: this.$route.query.cId
          }).then((response) => {
            if (!response.data) {
              this.$message.error('同步异常')
            }
          })
        }, handoutInfo.lectureMinute * 60 * 1000)
      }
      
    })
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    /**
     * @description: 查询培训班详情
     */
    getTrainingById() {
      const params = {
        id: this.$route.query.tId,
        userId: this.userInfo.id
      }
      getTrainingById(params).then(res => {
        const training = res.data.data.training
        if (training.limitSingleDeviceLearning === 1) {
          VerifyDeviceBinding(this.userInfo.id)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Handout.vue